import { render } from "./News.vue?vue&type=template&id=04511853"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=04511853&lang=css"
script.render = render

export default script